import { Button } from "antd";
import { ProjectIntegrationsTabSharedContext } from "pages/project-setting-menu/project-integrations/project-integrations-tab-context";
import { useContext } from "react";
import { useHistory } from "react-router";

export default function ProjectIntegrationListMessage(params: {
  onConfigureClick: () => void;
}) {
  const { onConfigureClick } = params;
  const history = useHistory();
  const { sharedState } = useContext(ProjectIntegrationsTabSharedContext);

  const msgProjectNotConfigured = (
    <>
      <Button
        size="small"
        type="text"
        className="font-medium workflow-document-upload"
        onClick={onConfigureClick}
        data-testid="configure-integration-button"
      >
        Click here
      </Button>
      <span>to add Integration.</span>
    </>
  );

  const msgSubscriptionNotConfigured = (
    <>
      <Button
        size="small"
        type="text"
        className="font-medium workflow-document-upload"
        onClick={() => {
          history.push("/settings/integrations");
        }}
        data-testid="go-to-subscription-settings-button"
      >
        Click here
      </Button>
      <span>to add Integration.</span>
    </>
  );

  return (
    <div className="absolute top-[45%] z-50 left-0 right-0 flex items-center justify-center text-sm space-x-1">
      {!sharedState.subscriptionIntegrationConfigs?.length
        ? msgSubscriptionNotConfigured
        : msgProjectNotConfigured}
    </div>
  );
}
